import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from './pages/Layout.tsx';
import Home from './pages/Home.tsx';
import Login from './pages/Login.tsx';
import NotFound from './pages/NotFound.tsx';
import { MailProvider, useMail } from './contexts/Mail.tsx';
import { AdminProvider } from './contexts/Admin.tsx';
import InternalServerError from './pages/500.tsx';
import AdminLayout from './pages/admin/AdminLayout.tsx';
import AdminLogin from './pages/admin/AdminLogin.tsx';
import Setup from './pages/admin/Setup.tsx';
import Settings from './pages/admin/Settings.tsx';
import Announcement from './pages/admin/Announcement.tsx';
import AdminTokens from './pages/admin/AdminTokens.tsx';
import Users from './pages/admin/Users.tsx';
import Stats from './pages/admin/Stats.tsx';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useMail();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return <>{children}</>;
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useMail();
  
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  
  return <>{children}</>;
}

function App() {
  return (
    <MailProvider>
      <AdminProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            } />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Settings />} />
              <Route path="login" element={<AdminLogin />} />
              <Route path="setup" element={<Setup />} />
              <Route path="announcement" element={<Announcement />} />
              <Route path="admin-tokens" element={<AdminTokens />} />
              <Route path="users" element={<Users />} />
              <Route path="stats" element={<Stats />} />
            </Route>
            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }>
              <Route index element={<Home />} />
            </Route>
            <Route path="/500" element={<InternalServerError />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AdminProvider>
    </MailProvider>
  );
}

export default App;
